import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTransactionRecords = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#5ec4b6",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "DocumentType",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "TransactionRecords",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M14 2H2C1.44772 2 1 2.44772 1 3V13C1 13.5523 1.44772 14 2 14H14C14.5523 14 15 13.5523 15 13V3C15 2.44772 14.5523 2 14 2Z",
					fill: "currentColor",
					fillOpacity: .25,
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M4 5.5H8",
					stroke: "currentColor",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M4 8H7",
					stroke: "currentColor",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M4 10.5H6",
					stroke: "currentColor",
					strokeLinecap: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M10 5L12 6.5L10 8",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M12 9L10 10.5L12 12",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})
	})
});
export default SvgTransactionRecords;
